// Add your custom JS here.
jQuery(document).ready(function () {
    function toggleColor(toggleScope, toggleType) {
        var openColorClass = jQuery(toggleScope).data('open-color-class');
        var closeColorClass = jQuery(toggleScope).data('close-color-class');

        if (typeof openColorClass == "undefined" && typeof closeColorClass == "undefined") {
            return;
        }

        if (toggleType != 'toggle') {
            jQuery(toggleScope).find('span').addClass(closeColorClass);
            jQuery(toggleScope).find('span').removeClass(openColorClass);
            return;
        }

        jQuery(toggleScope).find('span').toggleClass(openColorClass);
        jQuery(toggleScope).find('span').toggleClass(closeColorClass);
    }

    function toggleContent(toToggle, toggleScope, toggleType) {
        if (!toggleType || typeof toggleType == "undefined") {
            toggleType = 'toggle';
        }

        jQuery(toToggle).animate({
            height: toggleType
        }, "slow");

        var openIcon = jQuery(toggleScope).data('open-icon');
        var closeIcon = jQuery(toggleScope).data('close-icon');

        if (typeof openIcon == "undefined" || typeof closeIcon == "undefined") {
            openIcon = 'icon-plus1';
            closeIcon = 'icon-minus1';
        }

        if (toggleType != "toggle") {
            jQuery(toggleScope).find('i').addClass(openIcon);
            jQuery(toggleScope).find('i').removeClass(closeIcon);
            toggleColor(toggleScope, toggleType);
            return;
        }

        var currentIconOpen = jQuery(toggleScope).find('i').hasClass(openIcon);
        var newIcon = currentIconOpen ? closeIcon : openIcon;

        jQuery(toggleScope).find('i').toggleClass(openIcon);
        jQuery(toggleScope).find('i').toggleClass(closeIcon);
        toggleColor(toggleScope, toggleType);

        var text = jQuery(toggleScope).children('span').html().trim();
        if (typeof text == "undefined") {
            return;
        }
        if (currentIconOpen && text.search('read more') != -1) {
            jQuery(toggleScope).children('span').html(text.replace('read more', 'read less'));
        }
        if (!currentIconOpen && text.search('read less') != -1) {
            jQuery(toggleScope).children('span').html(text.replace('read less', 'read more'));
        }
    }
    jQuery(".bc_toggle_content").on('click', function (e) {
        e.preventDefault();
        var dataToToggle = jQuery(this).data('toggle');
        var dataToggleGroup = jQuery(this).data('toggle-group');
        toggleContent(dataToToggle, this);
        if (typeof dataToggleGroup != "undefined") {
            jQuery(".bc_toggle_content").each(function () {
                var dataToToggleNow = jQuery(this).data('toggle');
                if (jQuery(this).data('toggle-group') != dataToggleGroup || dataToToggle == dataToToggleNow) {
                    return;
                }
                toggleContent(dataToToggleNow, this, 'hide');
            });
        }
    });

    jQuery(".bc_toggle_btn").on('click', function (e) {
        e.preventDefault();
        console.log(jQuery(this).closest(".bc_homepage"))
        if (jQuery(this).hasClass("bc_toggle_btn_closed")) {
            jQuery("html, body").animate({
                scrollTop: jQuery(this).closest(".bc_homepage").offset().top - 350
            }, 300);
            jQuery(this).removeClass("bc_toggle_btn_closed");
        } else {
            jQuery('html, body').animate({
                scrollTop: jQuery(this).closest(".bc_homepage").offset().top - 350
            }, 300);
            jQuery(this).addClass("bc_toggle_btn_closed");
        }
    });

});